import { tracked } from '@glimmer/tracking';
import Service, { service } from '@ember/service';

export default class ClinicianSearchService extends Service {
  @service store;
  @service currentPractice;
  @service session;

  @service('clinician-search/facet-names') facetNames;
  @service('clinician-search/preselection') preselection;
  @service('clinician-search/preselection-navigation') preselectionNavigation;
  @service('clinician-search/query') query;
  @service('clinician-search/send-all') sendAll;
  @service('clinician-search/next-slots') nextSlots;
  @service('clinician-search/clinician-details') clinicianDetails;
  @service('clinician-search/mobile') mobile;

  @tracked searchExperienceOverride = null;

  constructor() {
    super(...arguments);
    this.nextSlots.setOnBatchComplete(ids => this.clinicianDetails.enrich(ids));
  }

  resetState() {
    this.searchExperienceOverride = null;
    this.mobile.resetState();
    this.query.resetState();
    this.sendAll.resetState();
    this.nextSlots.resetState();
    this.clinicianDetails.resetState();
    this.preselection.resetState();
    this.preselectionNavigation.resetState();
  }

  get isEnabled() {
    if (this.session.currentClient) {
      return false;
    }

    if (this.searchExperienceOverride === 'advanced') {
      return true;
    }

    if (this.searchExperienceOverride === 'simple') {
      return false;
    }

    return Boolean(this.currentPractice.get('clinicianFilteringEnabled'));
  }
}
